import React from 'react'
import { Text } from '../../themes/userq/Text/Text'
import { Icon } from '../../themes/userq/Icon/Icon'
import { Button } from '../../themes/userq/Button/Button'
import { useNavigate } from 'react-router-dom'

export default function DeviceNotSupported(){
    const navigate = useNavigate();

return(
<div className='full-screen'>

<div className='text-center'>
<div className='mb-20 d-flex justify-content-center'>
<img width={'114px'} src={ process.env.REACT_APP_URL + "img/device.png" } />

</div>
<div className='mb-20'>

<Text type={'subtitle-2'} fontWeight={'semi-bold-font'}>This test is available on desktop only</Text>
</div>
<br/>
<Button  type={'primary' } size={'large'} iconLeft={
<Icon value={'back-arrow'} colorClass={'gray-50-svg'}/>
} label={'Back to Dashboard'} onClick={()=>{
    navigate('/dashboard');
}} />


</div>

</div>
)
}